import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";

import AdminTabs from "../Admin/AdminTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import Login from "../../Authentication/Login";
import { useNavigate } from "react-router-dom";

const initialFieldValues = {
  accountId: "00000000-0000-0000-0000-000000000000",
  accountTypeId: "00000000-0000-0000-0000-000000000000",
  parentAccountId: "00000000-0000-0000-0000-000000000000",
  accountName: "",
  accountCode: "",
  isTaxAccount: "",
};

const Account = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [accountTypes, setAccountTypes] = useState([]);
  const [accounts, setAccounts] = useState([]);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setAddShow(true);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETACCOUNTS}`,
      pageSize,
      pageNumber
    );
    console.log(res);
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };

  const GetAccountTypes = async () => {
    const res = await apiService.getAll(config.GETALLACCOUNTTYPES);
    setAccountTypes(res);
  };
  const GetAccounts = async () => {
    const res = await apiService.getAll(config.GETALLACCOUNTS);
    setAccounts(res);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };

  const GetFirstPageData = () => {
    GetData("1");
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEACCOUNT, itemToDelete);
        await GetData(pageNumber);
        GetAccounts();
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.accountCode = values.accountCode === "" ? false : true;
    temp.accountName = values.accountName === "" ? false : true;
    temp.accountTypeId =
      values.accountTypeId === "00000000-0000-0000-0000-000000000000"
        ? false
        : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        accountId: values.accountId,
        accountTypeId: values.accountTypeId,
        parentAccountId: values.parentAccountId,
        accountName: values.accountName,
        accountCode: values.accountCode,
        isTaxAccount: values.isTaxAccount,
      };
      try {
        const isNew =
          formData.accountId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEACCOUNT, formData);
        } else {
          await apiService.update(config.UPDATEACCOUNT, formData);
        }
        await GetData(pageNumber);
        GetAccounts();
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = ["accountName", "accountCode", "isTaxAccount"];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
      GetAccountTypes();
      GetAccounts();
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AdminTabs pageName="ACCOUNTS" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Account
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Account Code</th>
                          <th>Account Name</th>
                          <th>Account Type</th>
                          <th>Parent Account</th>
                          <th>Tax Account</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.accountId}>
                              <td>{index + 1}</td>
                              <td>{v.accountCode}</td>
                              <td>{v.accountName}</td>
                              <td>{v.typeName}</td>
                              <td>{v.parentAccountName}</td>
                              <td>{v.isTaxAccount ? "Yes" : "No"}</td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.accountId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose}>
          <Modal.Header>
            <Modal.Title>
              {values.accountId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Account
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="accountCode" className="form-label">
                    Account Code
                  </label>
                  <input
                    type="text"
                    value={values.accountCode}
                    name="accountCode"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("accountCode")}
                    placeholder="eg:1000"
                    maxLength={5}
                  />
                  {errors.accountCode === false ? (
                    <div className="validationerror">
                      Please enter account Code
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="accountTypeId" className="form-label">
                    Account Type
                  </label>
                  <select
                    name="accountTypeId"
                    value={values.accountTypeId}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("accountTypeId")}
                  >
                    <option value="00000000-0000-0000-0000-000000000000">
                      Select Account Type
                    </option>
                    {accountTypes.map((type) => (
                      <option
                        key={type.accountTypeId}
                        value={type.accountTypeId}
                      >
                        {type.typeName}
                      </option>
                    ))}
                  </select>
                  {errors.accountTypeId === false ? (
                    <div className="validationerror">
                      Please select account type
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="accountName" className="form-label">
                    Account Name
                  </label>
                  <input
                    type="text"
                    value={values.accountName}
                    name="accountName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("accountName")}
                    placeholder="Please Enter Account Name"
                    maxLength={100}
                  />
                  {errors.accountName === false ? (
                    <div className="validationerror">
                      Please enter account name
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-lg-12 mb-3">
                  <label htmlFor="parentAccountId" className="form-label">
                    Parent Account
                  </label>
                  <select
                    name="parentAccountId"
                    value={values.parentAccountId}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="00000000-0000-0000-0000-000000000000">
                      Select Parent Account (Optional)
                    </option>
                    {accounts.map((account) => (
                      <option key={account.accountId} value={account.accountId}>
                        {account.accountName} ({account.accountCode})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="isTaxAccount" className="form-label">
                    Is Tax Account
                  </label>
                  <select
                    name="isTaxAccount"
                    value={values.isTaxAccount}
                    onChange={(e) => {
                      const isTax = e.target.value === "true";
                      setValues({
                        ...values,
                        isTaxAccount: isTax,
                      });
                    }}
                    className="form-select"
                  >
                    <option value="">Please Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.accountId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default Account;
